module.exports = __webpack_public_path__ + "static/img/09.844711b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/travelpolicy/09.jpg
// module id = Ojq6
// module chunks = 0